(function (app) {

    app.provider("householdRelationshipApi",
        [
            function() {
                this.$get = [
                    "crmApiGateway", function(crmApiGateway) {
                        var service = {};

                        service.getHouseholdRelationships = function(clientId) {
                            return crmApiGateway.getArray("/Clients/" + clientId + "/HouseholdRelationships");
                        };

                        service.getHouseholdRelationship = function(relationshipId) {
                            return crmApiGateway.get("/HouseholdRelationships/" + relationshipId);
                        }

                        service.addHouseholdRelationship = function(clientId, relationship) {
                            return crmApiGateway.post("/Clients/" + clientId + "/HouseholdRelationships", relationship);
                        };

                        service.deleteHouseholdRelationship = function(relationshipId) {
                            return crmApiGateway.delete("/HouseholdRelationships/" + relationshipId);
                        };

                        service.updateType = function(relationship) {
                            return crmApiGateway.put("/HouseholdRelationships/" + relationship.Id, relationship);
                        };

                        return service;
                    }
                ];
            }
        ]);

})(window.app); // jshint ignore:line